import configureApolloClient from '../../../apollo/configureApolloClient';
import { DemoAthleteQuery } from '../../../clientState/demoAthlete/queries';
import { AthleteOptions } from '../types';
import { DEFAULT_PAGE_SIZE, withActivityListCore } from '../withActivityList';
import { DEFAULT_RESOLUTION } from '../withActivityStreams';
import { DemoActivityListQuery, DemoActivityQuery } from './queries';
import { fetchDemoActivityStreams } from './withDemoActivityStreams';

export async function fetchDemoActivityListFirstPage() {
    const client = configureApolloClient();

    return client.query({
        query: DemoActivityListQuery,
        variables: {
            input: {
                pageSize: DEFAULT_PAGE_SIZE
            }
        }
    });
}

/**
 * Fetches activity data from the server when the user mouses over
 * an activity in the activity list
 */
async function prefetchDemoActivity(id: string) {
    // We don't want to prefetch data on the server, so make sure
    // we're in the browser
    if ((process as any).browser) {
        const client = configureApolloClient();

        // First fetch the activity data
        await client.query({
            query: DemoActivityQuery,
            variables: {
                input: { id: id.toString() }
            }
        });

        // Then get the athlete data, which will normally
        // be cached already
        const {
            data: { demoAthlete }
        } = await client.query<{ demoAthlete: AthleteOptions }>({
            query: DemoAthleteQuery
        });

        // Last, fetch the activity stream data with the correct
        // arguments taken from the athlete info
        if (demoAthlete) {
            fetchDemoActivityStreams({
                id,
                resolution: demoAthlete.resolution || DEFAULT_RESOLUTION,
                selectedStreamType: demoAthlete.selectedActivityStreamType,
                types: demoAthlete.activityStreamTypes
            });
        }
    }
}

export default withActivityListCore(
    DemoActivityListQuery,
    'demoActivityList',
    prefetchDemoActivity
);



// WEBPACK FOOTER //
// ./src/client/components/Strava/Demo/withDemoActivityList.tsx